import api from "../../../services/api";

export const getMonthlyForecastWholesale = async (
  month = "2025-04",
) => {
  const response = await api.get("/api/forecast/wholesale/monthly_data", {
    params: { month },
  });
  return response.data;
};
